import { useTheme } from 'styled-components';
import { VehicleDetails as VehicleProps } from '../../../../API/types/Vehicles';
import { IconKeys } from '../../../../components/common/Icon/IconKeys';
import Tags from '../../../../components/common/Tags';
import { generateDistance } from '../../../../utils/unitsUtils';
import S from './AssignVehicleToDeviceStyles';
import useVehicleThumbnail from '../../../../theme/useVehicleThumbnail';
import { ThemeType } from '../../../../theme/themeType';
import { generateScoreColor, getScoreLabel, hasDisplayableEntityScore } from '../../../../utils/commonUtils';

type Props = {
  vehicle: VehicleProps;
  isChecked: boolean;
  selectVehicle: (vehicle: VehicleProps) => void;
};

function Vehicle({ vehicle, isChecked, selectVehicle }: Props): JSX.Element {
  const theme = useTheme() as ThemeType;
  const vehicleThumbnail = useVehicleThumbnail();
  const {
    _id: vehicleId,
    licensePlateNumber,
    model,
    distanceInKmTotal,
    score,
    device,
  } = vehicle;

  return (
    <S.VehicleWrapper
      onClick={() => {
        if (!device) {
          selectVehicle(vehicle);
        }
      }}
    >
      <input type="radio" name="sort-by" id={vehicleId} checked={isChecked} disabled />
      <label htmlFor={vehicleId}>
        {hasDisplayableEntityScore(score, distanceInKmTotal) && (
          <Tags.Status label={getScoreLabel(score)} backgroundColor={generateScoreColor(score)} />
        )}
        {!hasDisplayableEntityScore(score, distanceInKmTotal) && (
          <Tags.Status label="No score" backgroundColor={theme.colors.outline} title="This vehicle didn't have any trips yet." />
        )}
        {!device && (<span className="checkbox" />)}
      </label>
      <Tags.ItemOverview
        avatar={vehicleThumbnail}
        avatarAlt="vehicle"
        title={licensePlateNumber}
        subtitle={model}
      />
      <div className="tags-container">
        {!!vehicle.device?.deviceId && (
          <Tags.LabeledIcon
            label={`Connected device: ${vehicle.device.deviceId}`}
            icon={IconKeys.VIEW_ALL}
            flexible
          />
        )}
        <Tags.LabeledIcon
          label={generateDistance(distanceInKmTotal, true)}
          icon={IconKeys.DISTANCE}
        />
      </div>
    </S.VehicleWrapper>
  );
}

export default Vehicle;
